import { render } from "./Tentang.vue?vue&type=template&id=0aa78e77"
import script from "./Tentang.vue?vue&type=script&lang=js"
export * from "./Tentang.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__